var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Cart } from "./Cart";
import { getClassName, getHashOrPath, redirectToPage } from "../../helpers";
import { ERoute } from "../../helpers/Routes";
export var CartPage = function (props) {
    var onCheckout = React.useCallback(function (formValues) {
        redirectToPage(getHashOrPath(ERoute.CHECKOUT));
    }, []);
    return React.createElement(Cart, __assign({}, props, { className: getClassName(props.className), onCheckout: onCheckout }));
};
